import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './flat.css';
import { Image, Label, UIHeading4, UIText2 } from '@cian/ui-kit';
import { Lock16 } from '@cian/ui-kit/prev';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Flat = function Flat(_ref) {
  var img = _ref.img,
    url = _ref.url,
    title = _ref.title,
    price = _ref.price,
    booked = _ref.booked,
    hasDecoration = _ref.hasDecoration,
    floor = _ref.floor;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['floor'],
      children: /*#__PURE__*/_jsxs(UIHeading4, {
        children: ["\u042D\u0442\u0430\u0436 ", floor]
      })
    }), /*#__PURE__*/_jsxs("a", {
      href: url,
      target: "_blank",
      className: clsx(styles['flat'], booked && styles['flat--booked']),
      rel: "noreferrer",
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['img'],
        children: [/*#__PURE__*/_jsx(Image, {
          borderRadius: "4px",
          display: "block",
          src: img,
          width: 80,
          height: 80,
          objectFit: "contain"
        }), booked && /*#__PURE__*/_jsx("div", {
          className: styles['img--booked'],
          children: /*#__PURE__*/_jsx(Lock16, {
            color: "current_color"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: clsx(styles['description'], booked && styles['description--booked']),
        children: [/*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          children: title
        }), /*#__PURE__*/_jsx(UIHeading4, {
          color: "current_color",
          children: price
        }), /*#__PURE__*/_jsx("div", {
          className: styles['labels'],
          children: hasDecoration && /*#__PURE__*/_jsx(Label, {
            color: "dark_100",
            background: "gray6_100",
            children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
          })
        })]
      })]
    })]
  });
};